'use strict';
import React from 'react';


export default class CheckoutPreviewTotal extends React.Component {
    render() {
        let products = this.props.cart.getIn(['totals', 'products']).toJS();
        let total = this.props.cart.getIn(['totals', this.props.cart.get('selected_payment')]).toJS();
        let payment = this.props.cart.getIn(['payment', this.props.cart.get('selected_payment')]).toJS();

        return (
            <div className="preview__totals">
                <div className="totals__left">
                    <div>Zwischensumme:</div>
                    <div>Versandkosten:</div>
                    <div className="sums__tax">Enthaltene 19% Mwst:</div>
                    <div className="sums__total">Gesamtsumme</div>
                </div>
                <div className="totals__right">
                    <div>{products.formatted}</div>
                    <div>{payment.formatted}</div>
                    <div className="sums__tax">{total.tax}</div>
                    <div className="sums__total">{total.formatted}</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/preview/checkoutPreviewTotal.jsx